module.exports = require('./lib/effects')


//////////////////
// WEBPACK FOOTER
// ./~/redux-saga/effects.js
// module id = 866
// module chunks = 0 1 3